/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AlbumDto } from '../models/AlbumDto';
import type { AlbumImageDto } from '../models/AlbumImageDto';
import type { CreateAlbumRequest } from '../models/CreateAlbumRequest';
import type { UpdateAlbumRequest } from '../models/UpdateAlbumRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AlbumsService {

  /**
   * @returns AlbumDto OK
   * @throws ApiError
   */
  public static listAlbums({
    projectKey,
    path,
  }: {
    projectKey: string,
    path: string,
  }): CancelablePromise<Array<AlbumDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/albums',
      path: {
        'projectKey': projectKey,
      },
      query: {
        'path': path,
      },
    });
  }

  /**
   * @returns AlbumDto OK
   * @throws ApiError
   */
  public static createAlbum({
    projectKey,
    requestBody,
  }: {
    projectKey: string,
    requestBody?: CreateAlbumRequest,
  }): CancelablePromise<AlbumDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/albums',
      path: {
        'projectKey': projectKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AlbumDto OK
   * @throws ApiError
   */
  public static getAlbum({
    projectKey,
    albumId,
  }: {
    projectKey: string,
    albumId: string,
  }): CancelablePromise<AlbumDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/albums/{albumId}',
      path: {
        'projectKey': projectKey,
        'albumId': albumId,
      },
    });
  }

  /**
   * @returns AlbumDto OK
   * @throws ApiError
   */
  public static updateAlbum({
    projectKey,
    albumId,
    requestBody,
  }: {
    projectKey: string,
    albumId: string,
    requestBody?: UpdateAlbumRequest,
  }): CancelablePromise<AlbumDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v2/projects/{projectKey}/albums/{albumId}',
      path: {
        'projectKey': projectKey,
        'albumId': albumId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static deleteAlbum({
    projectKey,
    albumId,
  }: {
    projectKey: string,
    albumId: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/projects/{projectKey}/albums/{albumId}',
      path: {
        'projectKey': projectKey,
        'albumId': albumId,
      },
    });
  }

  /**
   * @returns AlbumImageDto OK
   * @throws ApiError
   */
  public static listAlbumImages({
    projectKey,
    albumId,
  }: {
    projectKey: string,
    albumId: string,
  }): CancelablePromise<Array<AlbumImageDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/albums/{albumId}/images',
      path: {
        'projectKey': projectKey,
        'albumId': albumId,
      },
    });
  }

  /**
   * @returns AlbumImageDto OK
   * @throws ApiError
   */
  public static uploadAlbumImage({
    projectKey,
    albumId,
    formData,
  }: {
    projectKey: string,
    albumId: string,
    formData?: {
      File: Blob;
    },
  }): CancelablePromise<AlbumImageDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/albums/{albumId}/images',
      path: {
        'projectKey': projectKey,
        'albumId': albumId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static downloadAlbum({
    projectKey,
    albumId,
  }: {
    projectKey: string,
    albumId: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/albums/{albumId}/download',
      path: {
        'projectKey': projectKey,
        'albumId': albumId,
      },
    });
  }

}
